import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.sort";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { SortField } from "../../utils/helper";
export default {
  name: 'motor',
  data: function data() {
    return {
      // electricitySum: '',
      // electricityDay: '',
      mineTotalElectricityDay: '',
      downholeElectricityDay: '',
      transportElectricityDay: '',
      mineTotalElectricitySum: '',
      downholeElectricitySum: '',
      transportElectricitySum: '',
      TransportSalesDay: '',
      TransportSalesMonth: '',
      motor: '',
      motors: {},
      testConnect: "连接成功",
      connect: '',
      temp: '0.0',
      vibrationFrequency: '0.0',
      radioTreaty: '1',
      radioFlag: true,
      query: {
        Field1: '',
        Field2: '',
        PageIndex: 1,
        PageSize: 15
      }
    };
  },
  created: function created() {
    this.getData();
    this.getRealTimeData();
    this.selectMotor();
    this.getElectricPoweData();
    this.getTransportSalesData();
  },
  mounted: function mounted() {
    var _this = this;

    if (this.timer) {
      clearInterval(this.timer);
    } else {
      this.timer = setInterval(function () {
        _this.getRealTimeData();

        _this.getElectricPoweData();

        _this.getTransportSalesData();
      }, 1000 * 6);
    }
  },
  destroyed: function destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    radioChange: function radioChange(val) {
      this.radioFlag = val === '1' ? true : false;
    },
    getData: function getData() {
      var _this2 = this;

      this.$zybhttp.post('Motor/GetList', this.query).then(function (res) {
        if (res.data.status == 0) {
          res = res.data;
          var d = res.data.list;
          var newdata = d.sort(SortField('Id', 'desc'));
          newdata = newdata.map(function (x) {
            //console.log(x);
            x.isUseFt = x.isUse == '1';
            return x;
          }, []);
          _this2.motors = newdata;
          _this2.motor = newdata[0].name;
        } else {
          _this2.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this2.$notify.error('网络异常！获取列表失败！');
      });
    },
    getRealTimeData: function getRealTimeData() {
      var _this3 = this;

      this.$zybhttp.get('Motor/GetMotorMonitorRealTimeData', {}).then(function (res) {
        _this3.motor = _this3.$refs.selectMotor.selectedLabel;

        if (res.data.status == 0) {
          var data = res.data.data.list;

          for (var i = 0; i < data.length; i++) {
            if (data[i].MotorName == _this3.motor) {
              _this3.temp = data[i].temp;
              _this3.vibrationFrequency = data[i].vibrationFrequency;
              _this3.connect = data[i].connect;
            }
          }
        } else {
          _this3.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this3.$notify.error('网络异常！获取列表失败！');
      });
    },
    selectMotor: function selectMotor() {
      this.getRealTimeData();
    },
    getElectricPoweData: function getElectricPoweData() {
      var _this4 = this;

      this.$zybhttp.post('ProdInquiry/ElectricPoweData').then(function (res) {
        if (res.data.status == 0) {
          var d = res.data.data.list;
          _this4.logRecords = d; // this.electricitySum = res.data.msg;
          // this.electricityDay = res.data.info1;

          _this4.mineTotalElectricityDay = res.data.info1;
          _this4.downholeElectricityDay = res.data.info2;
          _this4.transportElectricityDay = res.data.info3;
          _this4.mineTotalElectricitySum = res.data.info4;
          _this4.downholeElectricitySum = res.data.info5;
          _this4.transportElectricitySum = res.data.info6;
        } else {
          _this4.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this4.$notify.error('网络异常！获取列表失败！');
      });
    },
    getTransportSalesData: function getTransportSalesData() {
      var _this5 = this;

      this.$zybhttp.post('ProdInquiry/TransportSalesData').then(function (res) {
        if (res.data.status == 0) {
          var d = res.data.data.list;
          _this5.logRecords = d;
          _this5.TransportSalesMonth = res.data.msg;
          _this5.TransportSalesDay = res.data.info1;
        } else {
          _this5.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this5.$notify.error('网络异常！获取列表失败！');
      });
    }
  }
};